export default "__VITE_ASSET__ChNiQN9X__"